const ERROR_MESSAGES = {
  LOAD_INFO: 'No se pudo obtener la información, intenta más tarde.',
  ACTION: 'No se pudo completar la acción, intenta más tarde.',
  CONNECTION: 'Sin conexión. Revisa tu internet e intenta de nuevo.',
};

export default ERROR_MESSAGES;
